import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from './services/language.service';
import { VersionService } from './services/version.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  private readonly languageService = inject(LanguageService);
  private readonly versionService = inject(VersionService);

  ngOnInit(): void {
    this.languageService.initializeLanguage();
    this.versionService.initialize();
  }
}
